import compact from 'lodash/compact';
import { StopPlaceInfoSpots } from '../../../../../types';
import { normalizeZoneLabel } from '../../../Types';
import { InfoSpotState, ItemSizeState, SizedDbItem } from '../Types';
import { mapStringToPurpose } from './infoSpotPurposeUtils';

function determineItemSize({
  width = null,
  height = null,
}: SizedDbItem): ItemSizeState {
  if (width !== null && height !== null) {
    return { uiState: 'EXISTING', width, height };
  }

  return { uiState: 'UNKNOWN', width, height };
}

export function mapInfoSpotDataToFormState(
  infoSpot: StopPlaceInfoSpots,
): InfoSpotState {
  return {
    infoSpotId: infoSpot.id ?? null,
    backlight: infoSpot.backlight ?? null,
    description: {
      lang: infoSpot.description?.lang ?? null,
      value: infoSpot.description?.value ?? null,
    },
    displayType: infoSpot.displayType ?? null,
    floor: infoSpot.floor ?? null,
    label: infoSpot.label ?? null,
    size: determineItemSize(infoSpot),
    infoSpotLocations: compact(infoSpot.infoSpotLocations),
    infoSpotType: infoSpot.infoSpotType ?? null,
    intendedUser: infoSpot.intendedUser ?? null,
    railInformation: infoSpot.railInformation ?? null,
    speechProperty: infoSpot.speechProperty ?? null,
    zoneLabel: normalizeZoneLabel(infoSpot.zoneLabel),
    poster: compact(infoSpot.poster).map((poster) => ({
      id: poster.id ?? null,
      label: mapStringToPurpose(poster.label),
      lines: poster.lines ?? null,
      size: determineItemSize(poster),
      sortOrder: poster.sortOrder ?? null,
      toBeDeletedPoster: false,
    })),
    sortOrder: infoSpot.sortOrder ?? null,
    toBeDeleted: false,
  };
}
